import useQuery from 'components/useQuery'
import { api } from 'api'
import { useEffect } from 'react'
import { useToast } from '@chakra-ui/react'

export const useLogin = () => {
  const toast = useToast()
  const {
    isError,
    isLoading,
    request,
    error,
  } = useQuery((data) => api.admin.login(data))

  useEffect(() => {
    if (isError) {
      toast({
        title: 'Ошибка',
        description: error.response?.data?.errorText,
        status: 'error',
      })
    }
  }, [isError])

  return {
    request,
    isLoading
  }
}
